<template>
    <v-autocomplete v-model="selectedItems"
                    :items="items"
                    deletable-chips
                    multiple
                    :return-object="true"
                    cache-items
                    :label="$t('search', {subject: $t('travel.menu.bike-trail')})"
                    item-value="id"
                    item-text="name"
                    small-chips>
        <template v-slot:item="{item}">
            {{item.name}}
        </template>
    </v-autocomplete>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {TrailAction} from "../../store/trails/types";

    export default {
        props: {
            value: {
                type: Array,
                required: true,
            },
        },
        created() {
            this.initialize();
        },
        watch: {
            selectedItems: {
                handler(selectedItems) {
                    this.$emit('input', selectedItems);
                }
            }
        },
        computed: {
            ...mapGetters({
                items: 'bikeTrails/autocomplete',
            }),
            selectedItems: {
                get() {
                    return this.value;
                },
                set(selectedItems) {
                    this.$emit('input', selectedItems);
                }
            }
        },
        methods: {
            ...mapActions({
                load: `bikeTrails/${TrailAction.AUTOCOMPLETE}`,
            }),
            initialize() {
                this.load();
            },
        },
    }
</script>
